import { recordAfterUpdate} from './CommonFn'
const INIT_STATE = {
    usersList : [],
    apiFail : false,
    blockSuccess : false,
    passwordModelVisible : false,
    passwordChange : false,
    updateUserSuccess : false,
    initialValues : null,

    resetPasswordSpinner : false,
    inviteUserLoader : false,
    corporateAccountsList : [],
    success : false,
    textMessage : '',
    invite_Modal : false,
    shouldClearForm : false,
    fetchLoader : false,
    resetPasswordModalVisible : false,
    corporateAccountSpinner : false,
    allManagers : [],
    allManagersSpinner : false,
    allCareRecipient : [],
    careRecipientSpinner : false

}
export default  (state = INIT_STATE, action) => {
    switch (action.type) {
            
        case 'gettingUserListSpinner_START':{
            return {
                ...state,
                userListSpinner : true
            }
        }
            case 'getUserList_SUCCESS':
            return {
                ...state,
                usersList : action.payload.Record,
                apiFail : false,
                userListSpinner : false
                
            }
            case 'getUserList_FAILURE':
                return {
                    ...state,
                    textMessage : 'could not fetch users list due to some error',
                    apiFail : true,
                    userListSpinner : false
                    
                }
            case 'updateUserStatus_SUCCESS' :{
                const roleArray = recordAfterUpdate(state.usersList, action.payload.Record);
                return {
                    ...state,
                    usersList: [...roleArray],
                    textMessage : 'user status has been updated successfully',
                    updateUserSuccess : true,
                    apiFail : false,
                }
            }

            case 'reset_Change' :{
                return {
                    ...state,
                    updateUserSuccess : false,
                    apiFail : false,
                    passwordChange:false
                }
            }



            case 'ResetPassword_Modal':{
                return {
                    ...state,
                    passwordModelVisible : !state.passwordModelVisible,
                    passwordChange : false,
                    apiFail : false,
                    initialValues : action.payload ? action.payload : null
                }
            }
            case 'changingUserPassword_START':{
                return {
                    ...state,
                    resetPasswordSpinner : true,
                }
            }
            case 'changingUserPassword_STOP':{
                return {
                    ...state,
                    resetPasswordSpinner : false,
                }
            }

            case 'changeUserPassword_SUCCESS':{
                return {
                    ...state,
                    textMessage : 'password has been changed successfully',
                    passwordChange : true,
                    passwordModelVisible : !state.passwordModelVisible,
                    apiFail : false,
                    resetPasswordSpinner : false,
                    success : true,
                }
            }
            case 'changeUserPassword_FAILURE':{
                return {
                    ...state,
                    textMessage : 'password could not be changes successfully',
                    error : true,
                    passwordModelVisible : !state.passwordModelVisible,
                    resetPasswordSpinner : false,
                }
            }



            case 'gettingCorporateAccounts_START': {
                return {
                    ...state,
                    corporateAccountSpinner: true
                }
            }
            case 'gettingCorporateAccounts_STOP': {
                return {
                    ...state,
                    corporateAccountSpinner: false
                }
            }
            case 'getCorporateAccounts_SUCCESS':
                return {
                    ...state,
                    usersList: action.payload.Record,

                    
                }
            case 'getCorporateAccounts_FAILURE':
                return {
                    ...state,
                    error: true,
                    textMessage: 'api error. try again!'
                }
            
            case 'gettingAllManager_START':{
                return {
                    ...state,
                    allManagersSpinner : true
                }
            }
            case 'gettingAllManager_STOP':{
                return {
                    ...state,
                    allManagersSpinner : false
                }
            }
                case 'getAllManager_SUCCESS':
                return {
                    ...state,
                    allManagers: action.payload.Record,
                    allManagersSpinner : false
                    
                }
            case 'getAllManager_FAILURE':
                return {
                    ...state,
                    error: true,
                    textMessage: 'api error. try again!',
                    allManagersSpinner : false
                }


            case 'gettingCareRecipient_START':{
                return {
                    ...state,
                    careRecipientSpinner : true
                }
            }
            case 'gettingCareRecipient_STOP':{
                return {
                    ...state,
                    careRecipientSpinner : false
                }
            }
                case 'getCareRecipient_SUCCESS':
                return {
                    ...state,
                    allCareRecipient: action.payload.Record,
                    careRecipientSpinner : false
                    
                }
            case 'getCareRecipient_FAILURE':
                return {
                    ...state,
                    error: true,
                    textMessage: 'api error. try again!',
                    careRecipientSpinner : false
                }


            case 'Invite_Modal': {
                return {
                    ...state,
                    invite_Modal: !state.invite_Modal,
                    initialValues : action.payload ? action.payload : null
                }
            }


            case 'invitingUser_START':{
                return {
                    ...state,
                    inviteUserLoader: true
                }
            }
            case 'invitingUser_STOP':{
                return {
                    ...state,
                    inviteUserLoader: false
                }
            }
            case 'inviteUser_SUCCESS': {
                return {
                    ...state,
                    usersList: [action.payload.Record, ...state.usersList],
                    success: true,
                    textMessage: "invite sent successfully",
                    invite_Modal: false,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }
            case 'inviteUser_FAILURE': {
                return {
                    ...state,
                    error: true,
                    textMessage: action.payload,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }
            case 'updateSubscribePlan_SUCCESS': {

                const updatedRecord = recordAfterUpdate(state.usersList,action.payload.Record)
                return {
                    ...state,
                    usersList: [...updatedRecord],
                    success: true,
                    textMessage: "record updated successfully!",
                    invite_Modal: false,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }
            case 'updateSubscribePlan_FAILURE': {
                return {
                    ...state,
                    error: true,
                    textMessage: "record updated failed. try again!",
                    invite_Modal: false,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }
            case 'editUser_SUCCESS': {

                const updatedRecord = recordAfterUpdate(state.usersList,action.payload.Record)
                return {
                    ...state,
                    usersList: [...updatedRecord],
                    success: true,
                    textMessage: "user updated successfully!",
                    invite_Modal: false,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }
            case 'editUser_FAILURE': {
                return {
                    ...state,
                    error: true,
                    textMessage: action.payload,
                    invite_Modal: false,
                    shouldClearForm: true,
                    initialValues: null,
                    inviteUserLoader :false
                }
            }

            case 'reInviteUser_SUCCESS':{
                return {
                    ...state,
                    success : true,
                    textMessage : 'Re Invite sent successfully!'
                }
            }
            case 'reInviteUser_FAILURE':{
                return {
                    ...state,
                    error : true,
                    textMessage : action.payload
                }
            }



            case 'Reset_Password_Modal':{
                return {
                    ...state,
                    resetPasswordModalVisible : !state.resetPasswordModalVisible,
                    initialValues : action.payload ? action.payload : null
                }
            }

            case 'reset_corporateAccount_States': {
                return {
                    ...state,
                    success: false,
                    error: false,
                    inviteUserLoader: false,
                    shouldClearForm: true,
                    textMessage: '',
                    allManagersSpinner : false
                }
            }
        
        default:
            return state
    }
}


 